export default {
      id: "common__geozone_all-geozones-usage",
      viewBox: "0 0 24 19",
      url: __webpack_public_path__ + "img/icons.svg#common__geozone_all-geozones",
      toString: function () {
        return this.url;
      }
    }